// extracted by mini-css-extract-plugin
export var dark = "v_sB";
export var darkcookie = "v_sC";
export var tintedcookie = "v_sD";
export var regularcookie = "v_sF";
export var darkbase = "v_sG";
export var tintedbase = "v_sH";
export var regularbase = "v_sJ";
export var darkraw = "v_sK";
export var tintedraw = "v_sL";
export var regularraw = "v_sM";
export var darkchick = "v_sN";
export var tintedchick = "v_sP";
export var regularchick = "v_sQ";
export var darkherbarium = "v_sR";
export var tintedherbarium = "v_sS";
export var regularherbarium = "v_sT";
export var darkholiday = "v_sV";
export var tintedholiday = "v_sW";
export var regularholiday = "v_sX";
export var darkoffline = "v_sY";
export var tintedoffline = "v_sZ";
export var regularoffline = "v_s0";
export var darkorchid = "v_s1";
export var tintedorchid = "v_s2";
export var regularorchid = "v_s3";
export var darkpro = "v_s4";
export var tintedpro = "v_s5";
export var regularpro = "v_s6";
export var darkrose = "v_s7";
export var tintedrose = "v_s8";
export var regularrose = "v_s9";
export var darktimes = "v_tb";
export var tintedtimes = "v_tc";
export var regulartimes = "v_td";
export var darkwagon = "v_tf";
export var tintedwagon = "v_tg";
export var regularwagon = "v_th";